export default function NewPaybarNotificationSubscriptionUpdateFailed() {
  return (
    <div className="newPaybarNoticePaymentFailed">
      <span className="newPaybarNotice-message" dangerouslySetInnerHTML={{ __html: I18n.t(`newPaybar.notice.${this.props.product}.subscriptionUpdateFailed`) }} />
    </div>
  )
}
